import React, { useEffect, useState } from "react";
import {
  Accordion as DsmAccordion,
  Typography,
  Modal,
  Button,
  CircularLoader,
  Icon,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
import StatusChip from "../components/StatusChip";
import styled, { keyframes } from "styled-components";
import moment from "moment";
import { isLinkResendable, isLinkCancellable } from "../../../utils/reports";
import reportService from "../../../services/reportService";
import Date from "../components/Date";
import ToolTipText from "../components/ToolTipText";
import { NotificationManager } from "react-notifications";
import { getRewardType } from "./utils";
import ActivityTimeline from "./components/ActivityTimeline";
import { REWARD_TYPES } from "./constants";

const ViewDetailModal = styled(Modal).attrs()`
  height: 100vh;
  margin-right: 0;
  border-radius: 0;
  width: 420px;
  animation: ${({ isOpen }) => (isOpen ? slideIn : slideOut)} 0.5s forwards;
`;

const slideIn = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
`;

const AUTHENTICATE_TYPE_TEXT = {
  1: "Only the recipient of the code",
  2: (
    <>
      Only users with the same <br></br>domain as your account
    </>
  ),
  3: "Any user with the code",
};

const rewardTypeMapping = {
  "": "",
  2: REWARD_TYPES.XOXO_POINTS,
  3: REWARD_TYPES.XOXO_CODE,
  12: REWARD_TYPES.XOXO_LINK,
  6: REWARD_TYPES.PLUM_PRO
}

const Accordion = styled(DsmAccordion).attrs()`
  .view-detail-accordain-item {
    box-shadow: none;
  }
  .view-detail-accordain-item > div {
    padding: 8px 12px;
    border-radius: 0px;
    font-size: 12px;
    background: #f6f6f7;
  }
  .eui-accordion-title {
    font-weight: 500;
    font-size: 14px;
  }
  .eui-accordion-content {
    background: #fff !important;
  }
  .eui-accordion-icon {
    display: flex;
  }
`;

const DeliveryModes = ["Email", "SMS", "Both"];
const deniedStatus = ["Delivered", "Not Delivered"];

const Info = ({ label, value, reason }) => {
  if (!value) return null;
  return (
    <div className="d-flex align-items-center justify-content-between py-8">
      <Typography.BodySmall
        color="dark"
        shade="c200"
        className="mb-0"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: label }} />{" "}
        {label.toLowerCase() === "cancelled" && (
          <ReasonTooltipMsgShow reason={reason} />
        )}
      </Typography.BodySmall>

      <Typography
        color="dark"
        shade="c300"
        className="mb-0"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </Typography>
    </div>
  );
};
const ReasonTooltipMsgShow = ({ reason }) => {
  return (
    <Tooltip width={200} tooltip={<>{reason}</>} placement="bottom">
      <Icon className="ml-6 mb-1" iconName="Info" size={16} />
    </Tooltip>
  );
};
const ViewDetail = ({
  setUpdateReportPopup,
  viewDetailModalData,
  showViewDetailModal,
  setShowViewDetailModal,
  title: initialTitle,
  moduleId = "",
  type,
  activeTab
}) => {
  let title = "";
  if (viewDetailModalData?.xoxolink) {
    title = "reward link";
  } else {
    title = initialTitle;
  }
  const [loading, setLoading] = useState(false);
  const [activityTimeline, setActivityTimeline] = useState([""]);
  const [deliveryMethod, setDeliveryMethod] = useState(0);
  const phoneNumber =
    viewDetailModalData?.receiver_phone_number ||
    viewDetailModalData?.recipient_phone ||
    "";
  const phoneCode =
    viewDetailModalData?.receiver_phone_code ||
    viewDetailModalData?.phone_code ||
    "";
  let details = [
    {
      title: "Recipient details",
      data: {
        Name:
          viewDetailModalData?.receiver_name ||
            viewDetailModalData?.name ||
            viewDetailModalData?.recipient_name ? (
            <ToolTipText
              value={
                viewDetailModalData?.receiver_name ||
                viewDetailModalData?.name ||
                viewDetailModalData?.recipient_name
              }
            />
          ) : (
            ""
          ),
        Email:
          viewDetailModalData?.receiver_email ||
            viewDetailModalData?.email ||
            viewDetailModalData?.recipient_email ? (
            <ToolTipText
              value={
                viewDetailModalData?.receiver_email ||
                viewDetailModalData?.email ||
                viewDetailModalData?.recipient_email
              }
            />
          ) : (
            ""
          ),
        "Phone Number": phoneNumber
          ? phoneCode?.includes("+")
            ? `${phoneCode} ${phoneNumber}`
            : `+${phoneCode} ${phoneNumber}`
          : "",
      },
    },
    {
      title: "Product details",
      data: {
        Name: "",
      },
    },
    {
      title: "Other details",
      data: {
        "Consumed Points": viewDetailModalData?.points,
        "Additional Spend": viewDetailModalData?.additional_pay === 0 ? `${viewDetailModalData?.additional_pay}` : viewDetailModalData?.additional_pay,
      },
    },
    {
      title: "Reward details",
      data: {
        "Value of Link": viewDetailModalData?.denomination_value,
        "Mode of Delivery":
          title === "reward link"
            ? DeliveryModes[viewDetailModalData?.delivery_method - 1]
            : viewDetailModalData?.mode_of_delivery,
        "Sent On": viewDetailModalData?.generation_date
          ? moment(viewDetailModalData?.generation_date, "YYYY-MM-DD").format(
            "D MMM, YYYY"
          )
          : viewDetailModalData?.issued_date
            ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
              "D MMM, YYYY"
            )
            : "",
        Expiry: viewDetailModalData?.expiry_date
          ? moment(viewDetailModalData?.expiry_date, "YYYY-MM-DD").format(
            "D MMM, YYYY"
          )
          : "",
        "Who can redeem":
          (viewDetailModalData?.authentication_type &&
            AUTHENTICATE_TYPE_TEXT[viewDetailModalData?.authentication_type]) ||
          "",
        "Reward notes": viewDetailModalData?.notes ? (
          <ToolTipText value={viewDetailModalData?.notes} length={22} />
        ) : (
          ""
        ),
        "Current status": viewDetailModalData?.status,
        Campaign:
          viewDetailModalData?.campaignName &&
          viewDetailModalData?.products_count &&
          `${viewDetailModalData?.campaignName} - ${viewDetailModalData?.products_count} Vouchers`,
      },
    },
    {
      title: "Sender details",
      data: {
        "Sent By": viewDetailModalData?.sent_by ? (
          <ToolTipText value={viewDetailModalData?.sent_by} length={22} />
        ) : (
          ""
        ),
      },
    },
  ];

  const activityTimeLineObj = {
    title: "Activity Timeline",
    data: {
      "Delivered via SMS":
        viewDetailModalData?.sms_delivery_status ||
          viewDetailModalData?.sms_delivery_status
          ? viewDetailModalData?.issued_date
            ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
              "MMM D, YYYY"
            )
            : viewDetailModalData?.generation_date
              ? moment(
                viewDetailModalData?.generation_date,
                "YYYY-MM-DD"
              ).format("MMM D, YYYY")
              : null
          : null,
      "Delivered via Email":
        viewDetailModalData?.mail_delievery_status ||
          viewDetailModalData?.mail_delivery_status
          ? viewDetailModalData?.issued_date
            ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
              "MMM D, YYYY"
            )
            : viewDetailModalData?.generation_date
              ? moment(
                viewDetailModalData?.generation_date,
                "YYYY-MM-DD"
              ).format("MMM D, YYYY")
              : null
          : null,
      "Reward Sent": viewDetailModalData?.issued_date
        ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
          "MMM D, YYYY"
        )
        : viewDetailModalData?.generation_date
          ? moment(viewDetailModalData?.generation_date, "YYYY-MM-DD").format(
            "MMM D, YYYY"
          )
          : "",
    },
  }

  const statusDate = {};
  statusDate[viewDetailModalData?.status] =
    !deniedStatus.includes(viewDetailModalData?.status) &&
      viewDetailModalData?.date_modified
      ? moment(viewDetailModalData?.date_modified, "YYYY-MM-DD").format(
        "MMM D, YYYY"
      )
      : null;
  details[details.length - 1].data = {
    ...statusDate,
    ...details[details.length - 1].data,
  };

  if (title === "redemption history") {
    viewDetailModalData?.products?.map((product, index) => {
      details[1].data[
        (product?.product_name.length > 30
          ? product?.product_name?.slice(0, 30) + "..."
          : product?.product_name) +
        `<br /> <div class="mt-2" key={${index}}>Qty: ${product?.quantity}</div>` || ""
      ] = product?.denomination;
    });
    details[1].data[
      "Denomination Total"
    ] = `${viewDetailModalData?.totalDenomination}`;
    details[1].data["Order Total"] = viewDetailModalData?.order_total;
  }

  const getTitle = () => {
    let title = "";
    if (viewDetailModalData?.sales_order_id) {
      title = `Order ID ${viewDetailModalData?.sales_order_id}`;
    } else if (viewDetailModalData?.voucher_code) {
      title = `Voucher ID ${viewDetailModalData?.voucher_code}`;
    } else if (viewDetailModalData?.id) {
      title = `Voucher ID ${viewDetailModalData?.id}`;
    } else if (viewDetailModalData?.xoxolink) {
      title = `Xoxo Link ${viewDetailModalData?.xoxolink}`;
    } else if (viewDetailModalData?.order_id) {
      title = `Order ID ${viewDetailModalData?.order_id}`;
    }
    return title;
  };
  const resendCancelHandleClick = (resendCancel) => {
    setUpdateReportPopup(resendCancel);
    setShowViewDetailModal(false);
  };
  useEffect(() => {
    if (showViewDetailModal) {
      const reference_id = parseInt(viewDetailModalData?.unique_id || viewDetailModalData?.order_id);
      setLoading(true)
      reportService.fetchActivityTimeline({ "reference_id": reference_id, "reward_type": rewardTypeMapping[moduleId] }).then((res) => {
        let data = {}
        try {
          data = JSON.parse(res?.data?.fetchActivityTimeline?.data || "{}")
        } catch (e) {
          console.error("Error in parsing activity timeline data", e)
        }
        if (data?.error) {
          setActivityTimeline([])
        } else {
          const resendArray = Object.values(data?.data?.resend || {});
          const sortedResendArray = resendArray?.sort((a, b) => {
            const dateA = moment(a[0]?.created_at || "") || 0;
            const dateB = moment(b[0]?.created_at || "") || 0;
            return dateB - dateA;
          });
          const newActivityTimeline = [...sortedResendArray, data?.data?.send || []]
          setDeliveryMethod(data?.data?.delivery_method || 0)
          if (newActivityTimeline?.length > 0) {
            setActivityTimeline(newActivityTimeline)

          } else {
            setActivityTimeline([])
          }
        }
        setLoading(false)
      }).catch((e) => {
        setLoading(false)
        console.error("activity timeline api failed", e)
      })
    }
  }, [showViewDetailModal, viewDetailModalData])

  if (activityTimeline?.length === 0 && !loading) {
    details.push(activityTimeLineObj)
  }

  return (
    <ViewDetailModal
      isOpen={showViewDetailModal}
      onClose={() => {
        setShowViewDetailModal(false);
      }}
      disableCloseButton={false}
      timeout={0}
      className="p-0"
    >
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <Typography.H3 className="p-20">{getTitle()}</Typography.H3>
          <hr className="m-0" />
          <div className="d-flex align-items-center pt-20 px-20 pb-8">
            <Typography.LabelText component="span" className="mr-4">
              Status:
            </Typography.LabelText>
            <StatusChip
              value={
                viewDetailModalData?.status ||
                viewDetailModalData?.redemption_status ||
                viewDetailModalData?.order_product_status ||
                viewDetailModalData?.delivery_status
              }
              className={viewDetailModalData?.status == 'Partially Redeemed' ? 'mr-6' : 'mr-20'}
              style={{ width: "auto" }}
            />
            <Typography.LabelText component="span" className="mr-4">
              {title === "redemption history" || title === "gift cards" ? "Order Date" : " Expiry:"}
            </Typography.LabelText>
            <Typography component="span">
              <Date
                value={
                  title === "redemption history" || title === "gift cards"
                    ? viewDetailModalData?.added_date?.slice(0, 10) || viewDetailModalData?.date_added?.slice(0, 10)
                    : viewDetailModalData?.expiry_date
                }
              />
            </Typography>
          </div>
          <div className="p-20">
            <Accordion
              onClick={() => { }}
              className="view-detail-accordain py-10"
              itemProps={{
                className: "view-detail-accordain-item",
              }}
            >
              {details.map((detail = {}, index) => {
                const hasValidValues = Object.values(detail.data).filter(
                  ($) => $
                ).length;

                return hasValidValues > 0 && detail ? (
                  <div title={detail.title} key={index}>
                    {Object.entries(detail.data).map(([key, value], idx) => {
                      return (
                        <Info
                          label={key}
                          value={value}
                          key={idx}
                          reason={viewDetailModalData.reason}
                        />
                      );
                    })}
                  </div>
                ) : null;
              })}

              {activityTimeline?.length > 0 && <div title="Activity Timeline" key="1">
                {loading ? <div className="d-flex justify-content-center w-100">
                  <CircularLoader />
                </div> : <div className="pt-2">
                    {activityTimeline?.map((timeline, index) => (
                    <ActivityTimeline
                      key={index}
                      timeline={timeline}
                      deliveryMethod={deliveryMethod}
                      activeTab={activeTab}
                        moduleId={moduleId}
                    />
                  )
                  )}
                </div>}
              </div>
              }

            </Accordion>
          </div>
        </div>
        {type === "empuls_report" && title === "empuls history" ? "" : (
          <div
            className="d-flex justify-content-end p-20"
            style={{
              gap: "12px",
            }}
          >

              <>
                <Button
                  variant="plain"
                  color="secondary"
                  onClick={() => {
                    resendCancelHandleClick("cancel");
                  }}
                  disabled={!isLinkCancellable(viewDetailModalData)}
                >
                  Cancel Reward
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    resendCancelHandleClick("resend");
                  }}
                  disabled={
                    !isLinkResendable(
                      viewDetailModalData,
                      title === "reward link"
                    )
                  }
                >
                  Resend Reward
                </Button>
            </>
          </div>
        )}
      </div>
    </ViewDetailModal>
  );
};

export default ViewDetail;
